import { useQuery } from '@tanstack/react-query'
import http from '../../utils/Http/Http'

const getLeadDetail = async (id) => {
	const response = await http({
		url: `/leads/${id}`,
		method: 'get',
	})

	return response.data
}

export default function useFetchLead(leadId) {
	const { data, isFetching, error } = useQuery({
		queryFn: () => getLeadDetail(leadId),
		queryKey: [`lead_${leadId}`],
		enabled: !!leadId,
	})

	return { loading: isFetching, leadDetails: data, error }
}
